module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/idp-landing/idp-landing.component.css
// module id = ./src/app/Screens/idp-landing/idp-landing.component.css
// module chunks = main